import { Component, OnDestroy, OnInit } from '@angular/core';
import 'chart.js/dist/Chart.min.js';
import 'chartjs-plugin-datalabels';
import { TranslateService } from 'ng2-translate';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { RegionService } from '../../../admin/user-management/region.service';
import { CustomDatePipe } from '../../../shared/utils/date.pipe';
import { UtilsService } from '../../../shared/utils/utils.service';
import { CampaignService } from '../../campaign/campaign.service';
import { SaisineService } from '../../saisine';
import { VIEW_NBSAISINE_BY_LICENCE, VIEW_RECTORAT_REQUEST_BY_STATUS, VIEW_REQUEST_BY_SCHOOL_AND_STATUS, VIEW_SAISINES_TOTAL_BY_STATUS, VIEW_SAISINE_BY_ACADEMY_AND_STATUS, VIEW_SAISINE_RECTORAT, VIEW_STUDENT_PROPOSITION_BY_STATUS, VIEW_STUDENT_USERS } from '../stat.component';
import { StatService } from '../stat.service';
import { Agregat } from './agregat.model';


declare var Chart: any;

@Component({
    selector: 'jhi-stat-graph',
    templateUrl: './stat-graph.component.html',
    styleUrls: ['./stat-graph.component.scss']
})
export class StatGraphComponent implements OnInit, OnDestroy {
    campaignYear: string;
    today = Date.now();

    statNationale: any[] = [];
    statNationaleKeys: any[] = [];
    statNationaleData: any;
    statNationaleOptions: any;
    totalStatNationale = 0;
    nbStudent = 0;

    statSaisineRectorat: any[] = [];
    statSaisineRectoratData: any;
    statSaisineRectoratOptions: any;
    totalSaisineRectorat = 0;

    statSaisineRegion: any[] = [];
    statSaisineRegionData: any;
    statSaisineRegionOption: any;
    totalSaisineRegion = [];

    statRequestRectorat: any[] = [];
    statRequestRectoratKeys: any[] = [];
    statRequestRectoratData: any;
    statRequestRectoratOptions: any;
    totalRequestRectorat = 0;

    statStudentProposition: any[] = [];
    statStudentPropositionKeys: any[] = [];
    statStudentPropositionData: any;
    statStudentPropositionOptions: any;
    totalStudentProposition = 0;

    statSaisineLicence: any[] = [];
    statSaisineLicenceData: any;
    statSaisineLicenceOptions: any;
    nbDisplaySaisineByLicence = 20;
    heightSaisineLicence = '200';
    btnDisplaySaisineLicence: Boolean = false;

    statRequestBySchool: any[] = [];
    statRequestBySchoolKeys: any[] = [];
    statRequestBySchoolData: any;
    statRequestBySchoolOptions: any;
    totalRequestBySchool = 0;
    heightRequestBySchool = '200';

    displayGraphNational = false;
    displayGraphRectorat = false;
    displayGraphRegion = false;
    displayGraphRequestRectorat = false;
    displayGraphStudentProposition = false;
    displayGraphSaisineLicence = false;
    displayGraphRequestBySchool = false;
    displayGraphAgregat = false;

    donneesGraphRectorat = true;
    donneesGraphRegion = true;
    donneesGraphSaisineLicence = true;
    donneesGraphAgregat = true;
    donneesGraphRequestBySchool = true;

    statAgregat: any[] = [];
    statAgregatData: any;
    statAgregatOptions: any;
    statAgregatDomaine: any[] = [];
    //              rouge      rose       violet    violetF     bleuF     bleu       bleuC       bleuVert  vertForet    vert     vertClair  jauneVert   jaune     jauneOrange  orange    orangeF     marron
    colorTable = ['#D32F2F', '#C2185B', '#7B1FA2', '#512DA8', '#303F9F', '#1976D2', '#0288D1', '#0097A7', '#00796B', '#388E3C', '#689F38', '#AFB42B', '#FBC02D', '#FFA000', '#F57C00', '#E64A19', '#5D4037'];
    //              jaune       bleu     rougeRose   vert      orange      violet
    colorTable2 = ['#fff200', '#00abbd', '#ed1c24', '#2fe137', '#f68b1f', '#9378b6'];
    colorTable3 = ['#ddca80', '#bb65a8', '#a68847', '#9d9fa2'];
    Math: any;
    objectKeys = Object.keys;

    private subscription: Subscription = new Subscription();

    constructor(

        private statService: StatService,
        public utilsService: UtilsService,
        public translateService: TranslateService,
        private saisineService: SaisineService,
        private datePipe: CustomDatePipe,
        public campaignService: CampaignService,
        private regionService: RegionService) {
        this.campaignYear = this.campaignService.getDisplayedCampaign();
        if (!Chart.pluginService.getAll().filter(p => p.id === 'background')[0]) {
            let translate = this.translateService;
            Chart.pluginService.register({
                id: 'background',
                beforeDraw: function (chart) {
                    const ctx = chart.chart.ctx;
                    ctx.save();
                    ctx.fillStyle = 'white';
                    ctx.fillRect(0, 0, ctx.canvas.clientWidth, ctx.canvas.clientHeight);
                    ctx.restore();
                },
                afterDraw: function(chart) {
                    if (!chart.data || chart.data.datasets.length === 0) {
                        let ctx = chart.chart.ctx;
                        let width = chart.chart.width;
                        let height = chart.chart.height;
                        chart.clear();
                        ctx.save();
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';
                        ctx.font = '14px normal "Helvetica Nueue"';
                        ctx.fillText(translate.instant('stat.empty_graph'), width / 2, height / 2);
                        ctx.restore();
                    }
                }
            });
        }
        Chart.defaults.global.defaultFontColor = 'black';
        Chart.scaleService.updateScaleDefaults('linear', {
            ticks: {
                min: 0,
                callback: function(val) {
                    return Number.isInteger(val) ? val : null;
                }
            }
        });
    }

    ngOnInit() {
        this.Math = Math;
        this.load();
    }

    load() {
        this.loadSaisineNational();
        this.loadSaisineRectorat();
        this.loadSaisineRegion();
        this.loadRequestRectorat();
        this.loadStudentProposition();
        this.loadSaisineLicence();
        this.loadAgregat();
        this.loadRequestBySchool();
    }

    loadSaisineNational() {
        this.displayGraphNational = false;
        this.subscription.add(this.statService.addStatValues(VIEW_STUDENT_USERS, this.campaignService.getDisplayedCampaign()).subscribe(result => {
            this.nbStudent = result[0] ? result[0].student_count : 0;
        }));
        this.subscription.add(this.statService.addStatValues(VIEW_SAISINES_TOTAL_BY_STATUS, this.campaignService.getDisplayedCampaign()).subscribe(stats => {
            if (stats.length > 0) {
                this.statNationale = stats[0];
                this.statNationaleKeys = this.objectKeys(stats[0]);
                this.statNationaleData = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Nombre de saisines',
                            backgroundColor: [
                                this.colorTable2[0],
                                this.colorTable2[4],
                                this.colorTable2[1],
                                this.colorTable2[2],
                                this.colorTable2[3],
                            ],
                            data: [],
                            datalabels: {
                                color: 'white',
                                formatter: function (value) {
                                    if (value !== 0) {
                                        return value;
                                    }
                                    return null;
                                }
                            }
                        }
                    ]
                };
                this.statNationaleKeys.forEach(statKey => {
                    if (statKey !== 'total') {
                        let label = this.translateService.instant('stat.graph_nationale.' + statKey);
                        this.statNationaleData.labels.push(label);
                    }
                });
                stats.map(stat => {
                    this.objectKeys(stat).map(key => {
                        this.statNationaleData.datasets[0].data.push(parseInt(stat[key], 10));
                        this.totalStatNationale += stat[key];
                    });
                });
                let total = this.totalStatNationale;
                this.statNationaleData.datasets[0].datalabels = {
                    formatter: function (value) {
                        let perc = Math.round((value * 100) / total);
                        if (perc > 5) {
                            return value + '\n' + perc + '%';
                        }
                        return null;
                    }
                };
                this.statNationaleOptions = {
                    title: {
                        display: true,
                        fontSize: 16,
                        text: this.translateService.instant('stat.graph_nationale.title', {valeur: this.totalStatNationale}),
                        lineHeight: 2.2
                    },
                    legend: {
                        position: 'right'
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                let totalData = 0;
                                data.datasets[tooltipItem.datasetIndex].data.forEach(item => {
                                    totalData += item;
                                });
                                let percent = Math.round((data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] * 100) / totalData);
                                return ' ' + data.labels[tooltipItem.index] + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + ' (' + percent + '%)';
                            }
                        }
                    }
                };
            }
            this.displayGraphNational = true;
        }));
    }

    loadSaisineRectorat() {
        this.displayGraphRectorat = false;
        this.subscription.add(this.statService.addStatValues(VIEW_SAISINE_RECTORAT, this.campaignService.getDisplayedCampaign()).subscribe(stats => {
            if (stats.length > 0) {
                const minDate = stats.reduce(function (a, b) { return a.first_date < b.first_date ? a : b; });
                const maxDate = stats.reduce(function (a, b) { return a.first_date > b.first_date ? a : b; });
                let currentDate = minDate.first_date;
                while (currentDate <= maxDate.first_date) {
                    const currentStat = stats.find(_ => _.first_date === currentDate);
                    const value = currentStat ? currentStat.nb_saisines : 0;
                    this.totalSaisineRectorat += value;
                    const datesplit = currentDate.split('-');
                    const date = new Date(datesplit[0], datesplit[1] - 1, datesplit[2]);
                    this.statSaisineRectorat.push({'t': this.datePipe.transform(date), 'y': value});
                    date.setDate(date.getDate() + 1);
                    currentDate = this.datePipe.transform(date, 'yyyy-MM-dd');
                }

                this.statSaisineRectoratData = {
                    labels: this.statSaisineRectorat.map(_ => _.t),
                    legend: false,
                    datasets: [
                        {
                            label: 'Nombre de saisines',
                            fill: false,
                            borderColor: this.colorTable2[1],
                            backgroundColor: this.colorTable2[1],
                            data: this.statSaisineRectorat,
                            datalabels: {
                                display: false
                            }
                        }
                    ]
                };
                this.statSaisineRectoratOptions = {
                    title: {
                        display: true,
                        fontSize: 16,
                        text: this.translateService.instant('stat.graph_rectorat.title', {valeur: this.totalSaisineRectorat}),
                        lineHeight: 2.2
                    },
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    scales: {
                        xAxes: [{
                            time: {
                                unit: 'day',
                                distribution: 'linear'
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return ' Nombre de saisines : ' + tooltipItem.yLabel;
                            }
                        }
                    }
                };
            }
            this.displayGraphRectorat = true;
        }));
    }

    loadSaisineRegion() {

        this.displayGraphRegion = false;
        this.statSaisineRegionData = {
            labels: [],
            datasets: []
        };
        this.totalSaisineRegion['total'] = 0;

        this.subscription.add(Observable.combineLatest(this.regionService.getRegions({'campaign': this.campaignService.getDisplayedCampaign()}), this.statService.addStatValues(VIEW_SAISINE_BY_ACADEMY_AND_STATUS, this.campaignService.getDisplayedCampaign())).subscribe(([regions, stats]) => {
            regions.forEach(region => {
                this.statSaisineRegionData.labels.push(region.academicRegionLabel);
            });
            this.statSaisineRegionData.labels.sort();

            if (stats.length > 0) {
                this.statSaisineRegion = stats;

                let statKeys = this.objectKeys(this.statSaisineRegion[0]);
                statKeys.forEach((key, index) => {
                    if (key !== 'academic_region_label') {
                        this.totalSaisineRegion[key] = 0;
                    }
                });
                const totalDataset = {
                    label: 'hidden',
                    data: [],
                    type: 'line',
                    datalabels: {
                        anchor: 'end',
                        align: 'top',
                        formatter: function (value) {
                            return value;
                        },
                        display: (context: any) => {
                            return true;
                        }
                    },
                    showLine: false,
                };
                this.statSaisineRegionData.labels.forEach(academicRegionLabel => {
                    let stat = this.statSaisineRegion.find(_ => _.academic_region_label === academicRegionLabel);
                    let totalLine = 0;
                    if (stat) {
                        statKeys.forEach((key, index) => {
                            if (key !== 'academic_region_label') {
                                totalLine += stat[key];
                            }
                        });
                    }
                    totalDataset.data.push(totalLine);
                });
                this.statSaisineRegionData.datasets.push(totalDataset);

                statKeys.forEach((key, index) => {
                    if (key !== 'academic_region_label') {
                        let dataset = {
                            label: this.translateService.instant('stat.graph_region.' + key),
                            backgroundColor: this.colorTable2[index],
                            data: [],
                            datalabels: {
                                display: false
                            }
                        };
                        this.statSaisineRegionData.labels.forEach(academicRegionLabel => {
                            let value = 0;
                            let stat = this.statSaisineRegion.find(_ => _.academic_region_label === academicRegionLabel);
                            if (stat) {
                                value =  stat[key];
                                this.totalSaisineRegion[key] += stat[key];
                                this.totalSaisineRegion['total'] += stat[key];
                            }
                            dataset.data.push(value);
                        });
                        this.statSaisineRegionData.datasets.push(dataset);
                    }
                });

                this.statSaisineRegionOption = {
                    title: {
                        display: true,
                        fontSize: 16,
                        text: this.translateService.instant('stat.graph_region.title'),
                        lineHeight: 2.2
                    },
                    tooltips: {
                        mode: 'x',
                        callbacks: {
                            title: function(tooltipItem, data) {
                                return data.labels[tooltipItem[0].index] + ' (' + data.datasets[0].data[tooltipItem[0].index] + ')';
                            },
                            label: function(tooltipItem, data) {
                                if (data.datasets[tooltipItem.datasetIndex].label !== 'hidden') {
                                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + tooltipItem.yLabel;
                                }
                                return null;
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                autoSkip: false
                            },
                            stacked: true,
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    },
                    legend: {
                        position: 'right',
                        labels: {
                            filter: function (item, chart) {
                                return item.text !== 'hidden';
                            }
                        }
                    },
                    elements: {
                        point: {
                            radius: 0,
                            hitRadius: 0,
                            hoverRadius: 0,
                        }
                    }
                };
            }
            this.displayGraphRegion = true;
        }));
    }

    loadRequestRectorat() {
        this.displayGraphRequestRectorat = false;
        this.subscription.add(this.statService.addStatValues(VIEW_RECTORAT_REQUEST_BY_STATUS, this.campaignService.getDisplayedCampaign()).subscribe(stats => {
            if (stats.length > 0) {
                let totalRequestRectorat = 0;
                this.statRequestRectorat = stats[0];
                this.statRequestRectoratKeys = this.objectKeys(stats[0]);
                this.statRequestRectoratData = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Nombre de saisines',
                            backgroundColor: [
                                this.colorTable2[0],
                                this.colorTable2[1],
                                this.colorTable2[2],
                                this.colorTable2[3]
                            ],
                            data: [],
                            datalabels: {}
                        }
                    ]
                };
                this.statRequestRectoratKeys.forEach(statKey => {
                    let label = this.translateService.instant('stat.graph_demande_admission.' + statKey + '_legend');
                    this.statRequestRectoratData.labels.push(label);
                });
                stats.map(stat => {
                    this.objectKeys(stat).map(key => {
                        this.statRequestRectoratData.datasets[0].data.push(parseInt(stat[key], 10));
                        totalRequestRectorat += stat[key];
                    });
                });
                this.totalRequestRectorat = totalRequestRectorat;
                this.statRequestRectoratData.datasets[0].datalabels = {
                    formatter: function (value) {
                        let perc = Math.round((value * 100) / totalRequestRectorat);
                        if (perc > 5) {
                            return value + '\n' + perc + '%';
                        }
                        return null;
                    }
                };
                this.statRequestRectoratOptions = {
                    title: {
                        display: true,
                        fontSize: 16,
                        text: this.translateService.instant('stat.graph_demande_admission.title', {'valeur': this.totalRequestRectorat}),
                        lineHeight: 2.2
                    },
                    legend: {
                        position: 'right'
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                let totalData = 0;
                                data.datasets[tooltipItem.datasetIndex].data.forEach(item => {
                                    totalData += item;
                                });
                                let percent = Math.round((data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] * 100) / totalData);
                                return ' ' + data.labels[tooltipItem.index] + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + ' (' + percent + '%)';
                            }
                        }
                    }
                };
            }
            this.displayGraphRequestRectorat = true;
        }));
    }

    loadStudentProposition() {
        this.displayGraphStudentProposition = false;
        this.subscription.add(this.statService.addStatValues(VIEW_STUDENT_PROPOSITION_BY_STATUS, this.campaignService.getDisplayedCampaign()).subscribe(stats => {
            let totalStudentProposition = 0;
            if (stats.length > 0) {
                this.statStudentProposition = stats[0];
                this.statStudentPropositionKeys = this.objectKeys(stats[0]);
                this.statStudentPropositionData = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Nombre de saisines',
                            backgroundColor: [
                                this.colorTable2[1],
                                this.colorTable2[2],
                                this.colorTable2[3]
                            ],
                            data: []
                        }
                    ]
                };
                this.statStudentPropositionKeys.forEach(statKey => {
                    let label = this.translateService.instant('stat.graph_proposition_etudiant.' + statKey + '_legend');
                    this.statStudentPropositionData.labels.push(label);
                });
                stats.map(stat => {
                    this.objectKeys(stat).map(key => {
                        this.statStudentPropositionData.datasets[0].data.push(parseInt(stat[key], 10));
                        totalStudentProposition += stat[key];
                    });
                });
                this.totalStudentProposition = totalStudentProposition;
                this.statStudentPropositionData.datasets[0].datalabels = {
                    formatter: function (value) {
                        let perc = Math.round((value * 100) / totalStudentProposition);
                        if (perc > 5) {
                            return value + '\n' + perc + '%';
                        }
                        return null;
                    }
                };
                this.statStudentPropositionOptions = {
                    title: {
                        display: true,
                        fontSize: 16,
                        text: this.translateService.instant('stat.graph_proposition_etudiant.title', {'valeur': this.totalStudentProposition}),
                        lineHeight: 2.2
                    },
                    legend: {
                        position: 'right'
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                let totalData = 0;
                                data.datasets[tooltipItem.datasetIndex].data.forEach(item => {
                                    totalData += item;
                                });
                                let percent = Math.round((data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] * 100) / totalData);
                                return ' ' + data.labels[tooltipItem.index] + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + ' (' + percent + '%)';
                            }
                        }
                    }
                };
            }
            this.displayGraphStudentProposition = true;
        }));
    }

    loadSaisineLicence() {
        this.displayGraphSaisineLicence = false;
        this.subscription.add(this.statService.addStatValues(VIEW_NBSAISINE_BY_LICENCE, this.campaignService.getDisplayedCampaign()).subscribe(stats => {
            if (stats.length > 0) {
                this.heightSaisineLicence = (80 + (25 * stats.length)) + 'px';
                this.statSaisineLicenceData = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Nombre de saisines',
                            backgroundColor: this.colorTable2[5],
                            data: [],
                            datalabels: {
                                display: false
                            }
                        }
                    ]
                };
                this.statSaisineLicence = stats;
                this.nbDisplaySaisineByLicence = this.statSaisineLicence.length;
                this.statSaisineLicence.slice(0, this.nbDisplaySaisineByLicence).map(stat => {
                    this.statSaisineLicenceData.labels.push(stat.licence_title);
                    this.statSaisineLicenceData.datasets[0].data.push(stat.nb_saisines);
                });
                this.statSaisineLicenceOptions = {
                    title: {
                        display: true,
                        fontSize: 16,
                        text: this.translateService.instant('stat.graph_filiere_tension.title'),
                        lineHeight: 2.2
                    },
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    tooltips: {
                        mode: 'y',
                        callbacks: {
                            title: function(tooltipItem, data) {
                                return data.datasets[0].label;
                            },
                            label: function(tooltipItem, data) {
                                return ' ' + tooltipItem.yLabel + ' : ' + tooltipItem.xLabel;
                            }
                        }
                    }
                };
            }
            this.displayGraphSaisineLicence = true;
        }));
    }

    loadAgregat() {
        this.displayGraphAgregat = false;
        this.subscription.add(Observable.combineLatest(this.saisineService.getMentions({'campaign': this.campaignService.getDisplayedCampaign()}), this.statService.addStatValues(VIEW_NBSAISINE_BY_LICENCE, this.campaignService.getDisplayedCampaign())).subscribe(([mentions, stats]) => {
            if (stats.length > 0) {
                let agregats = new Array<Agregat>();

                mentions.forEach(mention => {
                    if (!agregats.some(_ => _.subDomain === mention.subDomain)) {
                        const agregat = new Agregat();
                        agregat.subDomain = mention.subDomain;
                        agregat.domain = mention.domain;
                        agregat.color = mention.color;
                        stats.filter(_ => _.subDomain === agregat.subDomain).forEach(s => {
                            agregat.total += s.nb_saisines;
                        });
                        agregats.push(agregat);
                    }
                });

                stats.forEach(s => {
                    let m = mentions.find(mention => mention.mentionLabel === s.licence_title);
                    if (m) {
                        let agregat = agregats.find(_ => _.subDomain === m.subDomain);
                        if (agregat) {
                            agregat.total += s.nb_saisines;
                        } else {
                            agregat = new Agregat();
                            agregat.subDomain = m.subDomain;
                            agregat.domain = m.domain;
                            agregat.color = m.color;
                            agregat.total = s.nb_saisines;
                            agregats.push(agregat);
                        }
                    }
                });
                agregats = agregats.sort(function(a, b){
                    return (a.domain < b.domain) ? -1 : (a.domain > b.domain) ? 1 : (a.subDomain < b.subDomain) ? -1 : (a.subDomain > b.subDomain) ? 1 : 0;
                });
                agregats.forEach(a => {
                    let domain = this.statAgregatDomaine.find(_ => _.domain === a.domain);
                    if (domain) {
                        domain.total += a.total;
                    } else {
                        this.statAgregatDomaine.push({domain: a.domain, total: a.total});
                    }
                });

                this.statAgregat = agregats;
                // INIT DES DATAS
                this.statAgregatData = {
                    labels: agregats.map(_ => _.subDomain),
                    datasets: [
                        {
                            label: ' Nombre de saisines',
                            backgroundColor: agregats.map(_ => _.color),
                            data: agregats.map(_ => _.total),
                            datalabels: {
                                display: false
                            }
                        }
                    ]
                };
                // Init des domains pour la legend
                let domains = Array.from(agregats.reduce((m, t) => m.set(t.domain, t), new Map()).values());
                this.statAgregatOptions = {
                    title: {
                        display: true,
                        fontSize: 16,
                        text: this.translateService.instant('stat.graph_agregat.title'),
                        lineHeight: 2.2
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                autoSkip: false
                            },
                            stacked: true,
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    },
                    legend: {
                        display: true,
                        position: 'right',
                        labels: {
                            generateLabels: function (chart) {
                                let labels = [];
                                domains.forEach(domain => {
                                    labels.push({text: domain.domain, fillStyle: domain.color});
                                });
                                return labels;
                            }
                        },
                        onClick: function(e, legendItem) {}
                    },
                    tooltips: {
                        mode: 'x',
                        callbacks: {
                            title: function(tooltipItem, data) {
                                const agregat = agregats.find(_ => _.subDomain === tooltipItem[0].xLabel);
                                if (!agregat) {
                                    return null;
                                }
                                const domainAgregats = agregats.filter(_ => _.domain === agregat.domain);
                                if (!domainAgregats) {
                                    return null;
                                }
                                return agregat.domain + ' (' +  domainAgregats.reduce((prev, curr) => prev + curr.total, 0) + ')';
                            },
                            label: function(tooltipItem, data) {
                                return ' ' + tooltipItem.xLabel + ' : ' + tooltipItem.yLabel;
                            }
                        }
                    }
                };
            }
            this.displayGraphAgregat = true;
        }));
    }

    loadRequestBySchool() {
        this.displayGraphRequestBySchool = false;
        this.statRequestBySchoolData = {
            labels: [],
            datasets: []
        };
        this.subscription.add(this.statService.addStatValues(VIEW_REQUEST_BY_SCHOOL_AND_STATUS, this.campaignService.getDisplayedCampaign()).subscribe(stats => {
            if (stats.length > 0) {
                this.heightRequestBySchool = (80 + (25 * stats.length)) + 'px';

                this.statRequestBySchool = stats;
                // labels
                this.statRequestBySchool.map(stat => {
                    this.statRequestBySchoolData.labels.push(stat.master_school_label);
                });
                // data
                this.statRequestBySchoolKeys = this.objectKeys(stats[0]);
                this.statRequestBySchoolKeys.forEach((key, index) => {
                    if (key !== 'master_school_label') {
                        let dataset = {
                            label: this.translateService.instant('stat.graph_reponse_etablissement.' + key),
                            backgroundColor: this.colorTable2[index - 1],
                            data: [],
                            datalabels: {
                                display: false
                            }
                        };
                        this.statRequestBySchool.map(stat => {
                            dataset.data.push(stat[key]);
                            this.totalRequestBySchool += stat[key];
                        });
                        this.statRequestBySchoolData.datasets.push(dataset);
                    }
                });
                this.statRequestBySchoolOptions = {
                    title: {
                        display: true,
                        fontSize: 16,
                        text: this.translateService.instant('stat.graph_reponse_etablissement.title', {valeur: this.totalRequestBySchool}),
                        lineHeight: 2.2
                    },
                    tooltips: {
                        mode: 'y',
                        callbacks: {
                            title: function(tooltipItem, data) {
                                let total = 0;
                                tooltipItem.forEach(item => {
                                    total += item.xLabel;
                                });
                                return tooltipItem[0].yLabel + ' (' + total + ')';
                            },
                            label: function(tooltipItem, data) {
                                return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + tooltipItem.xLabel;
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            id: 'xaxe',
                            ticks: {
                                beginAtZero: true
                            },
                            stacked: true,
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    },
                    legend: {
                        position: 'right'
                    }
                };
            }
            this.displayGraphRequestBySchool = true;
        }));
    }


    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/stat/stat-graph/stat-graph.component.ts